import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  certificateUploaded: {
    id: 'studio.U5QCQI',
    defaultMessage: 'Certificate uploaded',
  },
});
